module.exports = __webpack_public_path__ + "static/material-gold.040a787a.svg";